define('constants/liveReceptionistScriptTransferOptionConstants',[], function() {
    return {
        Unknown: "0",
        None: "1",
        WarmOnly: "2",
        ColdOnly: "3",
        WarmAndCold: "4"
    };
});
